import * as React from 'react';

import { Text, Heading2 } from '@origin-digital/style-guide';
import { Box } from '@origin-digital/layout';

import { FindPlan } from '../FindPlan';
import { ButtonAction } from '../Button';
import { Card, PostcodeInputContainer, HeadingContainer } from './BannerPostcodePrompt.styles';
import { RippleLine } from '../SignUp/SignUp';
import { PostCodeInput } from '../FindPlan';

export const UnwrappedBannerPostcodePrompt = ({
  onSubmit,
  buttonUrl,
  active,
  ...postcodeInputProps
}) => {
  return (
    <Card>
      <HeadingContainer>
        <Heading2
          text="Switch to Origin in as little as 3 minutes"
          accessibilityLevel={1}
          color="grey56"
        />
      </HeadingContainer>
      <Box marginBottom={2}>
        <Text size="sm" color="grey56" fontWeight="medium">
          Your postcode
        </Text>
      </Box>
      <PostcodeInputContainer>
        <PostCodeInput
          {...postcodeInputProps}
          inputmode="numeric"
          pattern="[0-9]*"
          title="Postal Code"
          placeholder={3000}
          type="tel"
        />
        <RippleLine active={active} />
      </PostcodeInputContainer>
      <ButtonAction href={buttonUrl} onClick={onSubmit} tracking="banner-see-energy-plans">
        See energy plans
      </ButtonAction>
    </Card>
  );
};

export const BannerPostcodePrompt = () => {
  return (
    <FindPlan
      component={UnwrappedBannerPostcodePrompt}
      trackingId="banner-postcode-input"
      trackingLabel="Banner See energy plans"
      buttonUrl="/electricity-gas/plans.html"
    />
  );
};

BannerPostcodePrompt.displayName = 'BannerPostcodePrompt';
